<template>
	<div :class="[posterImageStatus ? 'noscroll product-con' : 'product-con']">
		<div style="position: relative;">
			<div style="width:100%;height: 7.5rem;position: absolute;background: rgba(0, 0, 0,0.7);z-index: 2;display: flex;align-items: center;" v-if="storeInfo.stock==0">
				<img src="http://app.funengtuan.com/imgs/noshop.png"  style="width:50%;margin:0 auto"/>
			</div>
			<div>
				<product-con-swiper :img-urls="storeInfo.slider_image"></product-con-swiper>
			</div>
		</div>
		<div class="wrapper">
			<div class="share acea-row row-between row-bottom">
				<div class="money font-color-red">
					<span class="num" v-if="level == '0'">{{ storeInfo.price }}元
						<span v-if="cartype == 3 || is_exchange == 1">
							(积分抵扣:{{ storeInfo.price?parseInt(storeInfo.price / integral_ratio):'' }})
						</span>
					</span>
					<span class="vip-money" v-else-if="level == '13'">
						至尊会员价：{{ storeInfo.diamond_price }}元
						<span v-if="cartype == 3 || is_exchange == 1">
							(积分抵扣:{{storeInfo.diamond_price?parseInt(storeInfo.diamond_price / integral_ratio):''}})
						</span>
					</span>
					<span class="vip-money" v-else>会员价：{{ storeInfo.regular_price }}元
						<span v-if="cartype == 3 || is_exchange == 1">
							(积分抵扣:{{storeInfo.regular_price?parseInt(storeInfo.regular_price / integral_ratio):''}})
						</span>
					</span>

					<!-- (积分抵扣:{{parseInt(storeInfo.vip_price/integral_ratio)}})
					(积分抵扣:{{parseInt(storeInfo.diamond_price/integral_ratio)}})
					(积分抵扣:{{parseInt(storeInfo.price/integral_ratio)}}) -->
					<!-- <span v-if="cartype==3"></span> -->
					<!--<img-->
					<!--src="@assets/images/vip.png"-->
					<!--class="image"-->
					<!--v-if="storeInfo.vip_price && storeInfo.vip_price > 0"-->
					<!--/>-->
				</div>
				<div class="iconfont icon-fenxiang" @click="listenerActionSheet"></div>
			</div>
			<div class="introduce">
				<div v-if="storeInfo.is_recipel==1" style="display: inline-block;width:2.5em;vertical-align: bottom;">
						<img src="http://app.funengtuan.com/imgs/rx.png" style="width:100%;vertical-align: text-top;" />
					</div>
				<!-- <div> -->
					{{ storeInfo.store_name }}
				<!-- </div> -->
			</div>
			<div class="label acea-row row-between-wrapper" style="align-items: start;">
				<div>
					<div>零售价:￥{{ storeInfo.price }}</div>
					<div>产地:{{ storeInfo.production_unit }}</div>
					<div v-if="storeInfo.is_quota">限购:{{ storeInfo.is_quota }}{{ storeInfo.unit_name }}</div>
				</div>
				<div>
					<div v-if="storeInfo.stock != 0">
						库存:{{ storeInfo.stock }}{{ storeInfo.unit_name }}
					</div>
					<div v-if="storeInfo.stock == 0" style="color: #FF0000;font-size: 32rpx;">
						库存:{{ storeInfo.stock }}{{ storeInfo.unit_name }}
					</div>
					<div>规格:{{ storeInfo.specs }}</div>
				</div>
				<div>销量:{{ storeInfo.sales }}{{ storeInfo.unit_name }}</div>
			</div>
			<div class="coupon acea-row row-between-wrapper" @click="couponTap"
				v-if="couponList.length && isusecoupon == 1">
				<div class="hide line1 acea-row">
					优惠券：
					<div class="activity" v-for="(item, index) in couponList" :key="index">
						满{{ item.use_min_price }}减{{ item.coupon_price }}
					</div>
				</div>
				<div class="iconfont icon-jiantou"></div>
			</div>
		</div>
		<div class="attribute acea-row row-between-wrapper" @click="selecAttrTap">
			<div>
				{{ attrTxt }}：<span class="atterTxt">{{ attrValue }}</span>
			</div>
			<div class="iconfont icon-jiantou"></div>
		</div>
		<div class="attribute acea-row row-between-wrapper" @click="selecAttrTap">
			<div>
				所属商家：
				<span class="atterTxt">{{ storeInfo.merchant_name }}</span>
			</div>
			<div v-if="storeInfo.merchant_parcel && storeInfo.merchant_parcel!=='0.00'">
				<span class="atterTxt">满{{ storeInfo.merchant_parcel }}包邮</span>
			</div>
		</div>
		<div class="userEvaluation" v-if="replyCount">
			<div class="title acea-row row-between-wrapper">
				<div>用户评价({{ replyCount }})</div>
				<router-link :to="{ path: '/evaluate_list/' + id }" class="praise"><span
						class="font-color-red">{{ replyChance }}%</span>好评率<span class="iconfont icon-jiantou"></span>
				</router-link>
			</div>
			<user-evaluation :reply="reply"></user-evaluation>
		</div>
		<div class="product-intro">
			<div class="title">产品介绍</div>
			<div class="conter" v-html="storeInfo.description"></div>
		</div>
		<div style="height:1.2rem;"></div>
		<div class="footer acea-row row-between-wrapper">
			<!--      <div
        class="item"
        @click="
          $router.push({ path: '/CustomerList123?mid=storeInfo.merchant_id' })
        "
      >
        <div class="iconfont icon-kefu"></div>
        <div>客服</div>
      </div> -->
			<!-- <router-link :to="'/CustomerList123?mid=' + merchant_id" class="item"> -->
			<router-link :to="{
          path: '/CustomerList123',
          query: { mid: merchant_id, productId: storeInfo.id }
        }" class="item">
				<div class="iconfont icon-kefu"></div>
				<div>客服</div>
			</router-link>
			<div class="item" @click="setCollect">
				<div class="iconfont" :class="storeInfo.userCollect ? 'icon-shoucang1' : 'icon-shoucang'"></div>
				<div>收藏</div>
			</div>
			<router-link :to="'/cart?mid=' + merchant_id + '&cartype=' + cartype" class="item animated"
				:class="animated === true ? 'bounceIn' : ''">
				<div class="iconfont icon-gouwuche1">
					<span class="num bg-color-red" v-if="CartCount > 0">{{
            CartCount
          }}</span>
				</div>
				<div>购物车</div>
			</router-link>
			<div class="bnt acea-row">
				<div class="joinCart" @click="joinCart">加入购物车</div>
				<div class="buy" @click="tapBuy">立即购买</div>
			</div>
		</div>
		<Share-red-packets :priceName="priceName" v-on:changeFun="changeFun" v-if="priceName !== 0  && isShowCard==true"></Share-red-packets>
		<CouponPop v-on:changeFun="changeFun" :coupon="coupon"></CouponPop>
		<Product-window v-on:changeFun="changeFun" :attr="attr"></Product-window>
		<StorePoster v-on:setPosterImageStatus="setPosterImageStatus" :posterImageStatus="posterImageStatus"
			:posterData="posterData" :showPrice="showPrice"></StorePoster>
		<ShareInfo v-on:setShareInfoStatus="setShareInfoStatus" :shareInfoStatus="shareInfoStatus"></ShareInfo>
		<div class="generate-posters acea-row row-middle" :class="posters ? 'on' : ''">
			<div class="item" v-if="weixinStatus === true" @click="setShareInfoStatus">
				<div class="iconfont icon-weixin3"></div>
				<div class="">发送给朋友</div>
			</div>
			<div class="item" @click="setPosterImageStatus">
				<div class="iconfont icon-haibao"></div>
				<div class="">生成海报</div>
			</div>
		</div>
		<div class="mask" @touchmove.prevent @click="listenerActionClose" v-show="posters"></div>
	</div>
</template>
<style>
	.mask {
		-webkit-filter: blur(2px);
		-moz-filter: blur(2px);
		-ms-filter: blur(2px);
		filter: blur(2px);
	}

	.footer .icon-shoucang1 {
		color: #e93323;
	}

	.product-con .product-intro .conter div {
		width: 100% !important;
	}

	.generate-posters {
		width: 100%;
		height: 1.7rem;
		background-color: #fff;
		position: fixed;
		left: 0;
		bottom: 0;
		z-index: 99;
		transform: translate3d(0, 100%, 0);
		-webkit-transform: translate3d(0, 100%, 0);
		-ms-transform: translate3d(0, 100%, 0);
		-moz-transform: translate3d(0, 100%, 0);
		-o-transform: translate3d(0, 100%, 0);
		transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
		-webkit-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
		-moz-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
		-o-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
	}

	.generate-posters.on {
		transform: translate3d(0, 0, 0);
		-webkit-transform: translate3d(0, 0, 0);
		-ms-transform: translate3d(0, 0, 0);
		-moz-transform: translate3d(0, 0, 0);
		-o-transform: translate3d(0, 0, 0);
	}

	.generate-posters .item {
		flex: 50%;
		-webkit-flex: 50%;
		-ms-flex: 50%;
		text-align: center;
	}

	.generate-posters .item .iconfont {
		font-size: 0.8rem;
		color: #5eae72;
	}

	.generate-posters .item .iconfont.icon-haibao {
		color: #5391f1;
	}

	.noscroll {
		height: 100%;
		overflow: hidden;
	}
</style>
<script>
	import ProductConSwiper from "@components/ProductConSwiper";
	import UserEvaluation from "@components/UserEvaluation";
	import ShareRedPackets from "@components/ShareRedPackets";
	import CouponPop from "@components/CouponPop";
	import ProductWindow from "@components/ProductWindow";
	import StorePoster from "@components/StorePoster";
	import ShareInfo from "@components/ShareInfo";
	import {
		getProductDetail,
		postCartAdd,
		getCartCount,
		getProductCode,
		getZiXun
	} from "@api/store";
	import {
		getCoupon,
		getCollectAdd,
		getCollectDel,
		getUserInfo,
		getUser
	} from "@api/user";
	import {
		imageBase64
	} from "@api/public";
	import {
		isWeixin
	} from "@utils/index";
	import {
		openShareAll
	} from "@libs/wechat";
	import {
		mapGetters
	} from "vuex";
	export default {
		name: "GoodsCon",
		components: {
			ProductConSwiper,
			UserEvaluation,
			ShareRedPackets,
			CouponPop,
			ProductWindow,
			StorePoster,
			ShareInfo
		},
		data: function() {
			const {
				id = 0, mid = 0, type = 0, is_exchange = 0
			} = this.$route.query;
			return {
				shareInfoStatus: false,
				weixinStatus: false,
				posterData: {
					image: "",
					title: "",
					price: "",
					code: ""
				},
				posterImageStatus: false,
				animated: false,
				coupon: {
					coupon: false,
					list: []
				},
				showPrice: true,
				attr: {
					cartAttr: false,
					productAttr: [],
					productSelect: {}
				},
				isOpen: false, //是否打开属性组件
				productValue: [],
				merchant_id: mid, //门店id
				id: id,
				cartype: type,
				level: 0,
				storeInfo: {},
				couponList: [],
				attrTxt: "请选择",
				attrValue: "",
				cart_num: 1, //购买数量
				replyCount: "",
				replyChance: "",
				reply: [],
				priceName: 0,
				integral_ratio: "0.01",
				CartCount: 0,
				is_exchange: is_exchange,
				is_yun: "",
				posters: false,
				isusecoupon: "",
				isShowCard:false
			};
		},
		computed: mapGetters(["isLogin"]),
		mounted: function() {
			if (this.$route.query.id) {
				this.id = this.$route.query.id;
				this.merchant_id = this.$route.query.mid;
			} else {
				this.id = this.$route.params.id;
				this.merchant_id = this.$route.params.mid;
			}
			this.productCon();
			this.coupons();
			this.getUsers()
			this.getCoupons();
		},
		methods: {
			updateTitle() {
				document.title = this.storeInfo.store_name || this.$route.meta.title;
			},
			getUsers(){
			  getUser().then(res1=>{
				  console.log(res1)
				  if(res1.data.is_shouyin==1 || res1.data.level==12 || res1.data.level==13){
				  	   this.isShowCard=true
				  }else{
					   this.isShowCard=false
				  }
			  })
			
			},
			getCoupons() {
				getZiXun().then(res => {
					this.isusecoupon = res.data.is_use_coupon;
				});
			},
			setOpenShare: function() {
				var data = this.storeInfo;
				var href = location.href;
				if (isWeixin()) {
					if (this.isLogin) {
						getUserInfo().then(res => {
							href =
								href.indexOf("?") === -1 ?
								href + "?spread=" + res.data.uid :
								href + "&spread=" + res.data.uid;
							let share_data = {
								desc: data.store_info,
								title: data.store_name,
								link: href,
								imgUrl: data.image
							};
							openShareAll(share_data);
						});
					} else {
						let share_data = {
							desc: data.store_info,
							title: data.store_name,
							link: href,
							imgUrl: data.image
						};
						console.log(share_data);
						openShareAll(share_data);
					}
				}
			},
			setShareInfoStatus: function() {
				this.shareInfoStatus = !this.shareInfoStatus;
				this.posters = false;
			},
			shareCode: function(value) {
				var that = this;
				getProductCode(that.id).then(res => {
					that.posterData.code = res.data.code;
					value === false && that.listenerActionSheet();
				});
			},
			setPosterImageStatus: function() {
				console.log(1);
				// var sTop = document.body || document.documentElement;
				// sTop.scrollTop = 0;
				this.posterImageStatus = !this.posterImageStatus;
				this.posters = false;
			},
			//产品详情接口；
			productCon: function() {
				let that = this;
				getProductDetail(that.id)
					.then(res => {
						if (res.data.storeInfo.merchant_id == 54) {
							that.is_yun = 1;
						} else {
							that.is_yun = 0;
						}
						that.$set(that, "merchant_id", res.data.storeInfo.merchant_id);
						that.$set(that, "storeInfo", res.data.storeInfo);
						that.$set(that.attr, "productAttr", res.data.productAttr);
						that.$set(that, "productValue", res.data.productValue);
						that.$set(that, "replyCount", res.data.replyCount);
						that.$set(that, "replyChance", res.data.replyChance);
						that.reply = res.data.reply ? [res.data.reply] : [];
						that.$set(that, "reply", that.reply);
						that.$set(that, "priceName", res.data.storeInfo.give_brokerage);
						that.$set(
							that,
							"integral_ratio",
							res.data.integral_ratio.replace(/\"/g, "")
						);
						that.posterData.image = that.storeInfo.image_base;
						if (that.storeInfo.store_name.length > 30) {
							that.posterData.title =
								that.storeInfo.store_name.substring(0, 30) + "...";
						} else {
							that.posterData.title = that.storeInfo.store_name;
						}
						that.level = res.data.level;
						that.posterData.price = that.storeInfo.price;
						that.posterData.code = that.storeInfo.code_base;
						if (that.isLogin) this.shareCode();
						that.updateTitle();
						that.DefaultSelect();
						that.getCartCount();
						that.getImageBase64();
						that.setOpenShare();
					})
					.catch(res => {
						that.$dialog.error(res.msg);
						that.$router.go(-1);
					});
			},
			getImageBase64: function() {
				let that = this;
				imageBase64(this.posterData.image, that.posterData.code)
					.then(res => {
						that.posterData.image = res.data.image;
						that.posterData.code = res.data.code;
					})
					.catch(res => {
						that.$dialog.error(res.msg);
					});
			},
			//默认选中属性；
			DefaultSelect: function() {
				let productAttr = this.attr.productAttr;
				let value = [];
				for (let i = 0; i < productAttr.length; i++) {
					this.$set(productAttr[i], "index", 0);
					value.push(productAttr[i].attr_values[0]);
				}
				//sort();排序函数:数字-英文-汉字；
				let productSelect = this.productValue[value.sort().join(",")];
				if (productSelect && productAttr.length) {
					this.$set(
						this.attr.productSelect,
						"store_name",
						this.storeInfo.store_name
					);
					this.$set(this.attr.productSelect, "image", productSelect.image);
					this.$set(this.attr.productSelect, "price", productSelect.price);
					this.$set(this.attr.productSelect, "stock", productSelect.stock);
					this.$set(this.attr.productSelect, "unique", productSelect.unique);
					this.$set(
						this.attr.productSelect,
						"vip_price",
						productSelect.vip_price
					);
					this.$set(this.attr.productSelect, "cart_num", 1);
					this.$set(this, "attrValue", value.sort().join(","));
					this.$set(this, "attrTxt", "已选择");
				} else if (!productSelect && productAttr.length) {
					this.$set(
						this.attr.productSelect,
						"store_name",
						this.storeInfo.store_name
					);
					this.$set(this.attr.productSelect, "image", this.storeInfo.image);
					this.$set(this.attr.productSelect, "price", this.storeInfo.price);
					this.$set(
						this.attr.productSelect,
						"vip_price",
						this.storeInfo.vip_price
					);
					this.$set(this.attr.productSelect, "stock", 0);
					this.$set(this.attr.productSelect, "unique", "");
					this.$set(this.attr.productSelect, "cart_num", 0);
					this.$set(this, "attrValue", "");
					this.$set(this, "attrTxt", "请选择");
				} else if (!productSelect && !productAttr.length) {
					this.$set(
						this.attr.productSelect,
						"store_name",
						this.storeInfo.store_name
					);
					this.$set(this.attr.productSelect, "image", this.storeInfo.image);
					this.$set(this.attr.productSelect, "price", this.storeInfo.price);
					this.$set(this.attr.productSelect, "stock", this.storeInfo.stock);
					this.$set(
						this.attr.productSelect,
						"vip_price",
						this.storeInfo.vip_price
					);
					this.$set(
						this.attr.productSelect,
						"unique",
						this.storeInfo.unique || ""
					);
					this.$set(this.attr.productSelect, "cart_num", 1);
					this.$set(this, "attrValue", "");
					this.$set(this, "attrTxt", "请选择");
				}
			},
			//购物车；
			ChangeCartNum: function(changeValue) {
				//changeValue:是否 加|减
				//获取当前变动属性
				let productSelect = this.productValue[this.attrValue];
				//如果没有属性,赋值给商品默认库存
				if (productSelect === undefined && !this.attr.productAttr.length)
					productSelect = this.attr.productSelect;
				//无属性值即库存为0；不存在加减；
				if (productSelect === undefined) return;
				let stock = productSelect.stock || 0;
				let num = this.attr.productSelect;
				if (changeValue) {
					num.cart_num++;
					if (num.cart_num > stock) {
						this.$set(this.attr.productSelect, "cart_num", stock);
						this.$set(this, "cart_num", stock);
					}
				} else {
					num.cart_num--;
					if (num.cart_num < 1) {
						this.$set(this.attr.productSelect, "cart_num", 1);
						this.$set(this, "cart_num", 1);
					}
				}
			},
			//将父级向子集多次传送的函数合二为一；
			changeFun: function(opt) {
				if (typeof opt !== "object") opt = {};
				let action = opt.action || "";
				let value = opt.value === undefined ? "" : opt.value;
				this[action] && this[action](value);
			},
			//打开优惠券插件；
			couponTap: function() {
				let that = this;
				that.coupons();
				that.coupon.coupon = true;
			},
			changecoupon: function(msg) {
				this.coupon.coupon = msg;
				this.coupons();
			},
			currentcoupon: function(res) {
				let that = this;
				that.coupon.coupon = false;
				that.$set(that.coupon.list[res], "is_use", true);
			},
			//可领取优惠券接口；
			coupons: function() {
				let that = this,
					q = {
						page: 1,
						limit: 20
					};
				getCoupon(q).then(res => {
					that.$set(that, "couponList", res.data || []);
					that.$set(that.coupon, "list", res.data);
				});
			},
			//打开属性插件；
			selecAttrTap: function() {
				this.attr.cartAttr = true;
				this.isOpen = true;
			},
			changeattr: function(msg) {
				this.attr.cartAttr = msg;
				this.isOpen = false;
			},
			//选择属性；
			ChangeAttr: function(res) {
				let productSelect = this.productValue[res];
				if (productSelect) {
					this.$set(this.attr.productSelect, "image", productSelect.image);
					this.$set(this.attr.productSelect, "price", productSelect.price);
					this.$set(this.attr.productSelect, "stock", productSelect.stock);
					this.$set(this.attr.productSelect, "unique", productSelect.unique);
					this.$set(
						this.attr.productSelect,
						"vip_price",
						productSelect.vip_price
					);
					this.$set(this.attr.productSelect, "cart_num", 1);
					this.$set(this, "attrValue", res);
					this.$set(this, "attrTxt", "已选择");
				} else {
					this.$set(this.attr.productSelect, "image", this.storeInfo.image);
					this.$set(this.attr.productSelect, "price", this.storeInfo.price);
					this.$set(
						this.attr.productSelect,
						"vip_price",
						this.storeInfo.vip_price
					);
					this.$set(this.attr.productSelect, "stock", 0);
					this.$set(this.attr.productSelect, "unique", "");
					this.$set(this.attr.productSelect, "cart_num", 0);
					this.$set(this, "attrValue", "");
					this.$set(this, "attrTxt", "请选择");
				}
			},
			//收藏商品
			setCollect: function() {
				let that = this,
					id = that.storeInfo.id,
					category = "product";
				if (that.storeInfo.userCollect) {
					getCollectDel(id, category).then(function() {
						that.storeInfo.userCollect = !that.storeInfo.userCollect;
					});
				} else {
					getCollectAdd(id, category).then(function() {
						that.storeInfo.userCollect = !that.storeInfo.userCollect;
					});
				}
			},
			//  点击加入购物车按钮
			joinCart: function() {
				//0=加入购物车
				this.goCat(0);
			},
			//立即购买；
			tapBuy: function() {
				//  1=直接购买
				this.goCat(1);
			},
			// 加入购物车；
			goCat: function(news) {
				let that = this,
					productSelect = that.productValue[this.attrValue];
				// if(this.storeInfo.is_recipel=="1"){
				// 	console.log(this.storeInfo.is_recipel)
				// 	that.$router.push({
				// 		path: "/recipel"
				// 	});
				// 	return false;
				// }
				//打开属性
				if (that.attrValue) {
					//默认选中了属性，但是没有打开过属性弹窗还是自动打开让用户查看默认选中的属性
					that.attr.cartAttr = !that.isOpen ? true : false;
				} else {
					if (that.isOpen) that.attr.cartAttr = true;
					else that.attr.cartAttr = !that.attr.cartAttr;
				}
				//只有关闭属性弹窗时进行加入购物车
				if (that.attr.cartAttr === true && that.isOpen === false)
					return (that.isOpen = true);
				//如果有属性,没有选择,提示用户选择
				if (that.attr.productAttr.length &&
					productSelect === undefined &&
					that.isOpen === true) {
					return that.$dialog.toast({
						mes: "产品库存不足，请选择其它"
					});
				}
				if(that.storeInfo.is_quota){
					if(that.attr.productSelect.cart_num>that.storeInfo.is_quota){
						return that.$dialog.toast({
							mes: "购买数量超出限制"
						});
					}
				}
				if (that.cartype == "3") {
					var is_integral = "1";
					var merchant_id = that.merchant_id;
				} else {
					var is_integral = "0";
					var merchant_id = that.merchant_id;
				}
				// console.log(merchant_id)
				// return false;
				let q = {
					productId: that.id,
					cartNum: that.attr.productSelect.cart_num,
					new: news,
					is_integral: is_integral,
					merchant_id: merchant_id,
					uniqueId: that.attr.productSelect !== undefined ?
						that.attr.productSelect.unique :
						""
				};
				postCartAdd(q)
					.then(function(res) {
						that.isOpen = false;
						that.attr.cartAttr = false;
						if (news) {
							// console.log(news);return false;
							that.$router.push({
								path: "/order/submit/" +
									res.data.cartId +
									"?merchant_id=" +
									merchant_id +
									"&is_integral=" +
									is_integral +
									"&is_exchange=" +
									that.is_exchange +
									"&is_yun=" +
									that.is_yun
							});
						} else {
							that.$dialog.toast({
								mes: "添加购物车成功",
								callback: () => {
									that.getCartCount(true);
								}
							});
						}
					})
					.catch(res => {
						that.isOpen = false;
						return that.$dialog.toast({
							mes: res.msg
						});
					});
			},
			//获取购物车数量
			getCartCount: function(isAnima) {
				let that = this;

				if (that.cartype == "3") {
					var is_integral = 1;
				} else {
					var is_integral = 0;
				}
				const isLogin = that.isLogin;
				if (isLogin) {
					getCartCount({
						numType: 0,
						merchant_id: that.merchant_id,
						is_integral: is_integral
					}).then(res => {
						console.log(res);
						that.CartCount = res.data.count;
						//加入购物车后重置属性
						if (isAnima) {
							that.animated = true;
							setTimeout(function() {
								that.animated = false;
							}, 500);
						}
					});
				}
			},

			listenerActionSheet: function() {
				if (isWeixin() === true) {
					this.weixinStatus = true;
				}
				this.posters = true;
			},
			listenerActionClose: function() {
				this.posters = false;
			}
		}
	};
</script>
